/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class S3Bucket {
  /**
  * The name of the bucket
  */
  'bucketName': string;
  /**
  * The region name where bucket is located
  */
  'regionName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "bucketName",
      "baseName": "bucketName",
      "type": "string",
      "format": ""
    },
    {
      "name": "regionName",
      "baseName": "regionName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return S3Bucket.attributeTypeMap;
  }

  public constructor() {
  }
}

